<template>
    <div class="col-xl-6 col-lg-6 col-md-6 group-row">
        <div class="group-row__label">
            {{ address_type.name }}
        </div>
        <div class="row">
            <div class="col-xl-12 col-lg-12 col-md-12">
                <div class="form-field form-field--text">
                    <label :for="`address_line_1_` + address_type.key"
                        >Address line 1</label
                    >
                    <input
                        v-model="form.address_line1"
                        type="text"
                        :readonly="is_same_hq"
                        :id="`address_line_1_` + address_type.key"
                        :name="
                            `address[` + address_type.key + `][address_line_1]`
                        "
                    />
                </div>
            </div>
            <div class="col-xl-12 col-lg-12 col-md-12">
                <div class="form-field form-field--text">
                    <label :for="`address_line_2_` + address_type.key"
                        >Address line 2</label
                    >
                    <input
                        v-model="form.address_line2"
                        :readonly="is_same_hq"
                        type="text"
                        :id="`address_line_2_` + address_type.key"
                        :name="
                            `address[` + address_type.key + `][address_line_2]`
                        "
                    />
                </div>
            </div>
            <div class="col-xl-12 col-lg-12 col-md-12">
                <div class="row jus-c--space-between">
                    <div class="col-xl-8 col-lg-8 col-md-8">
                        <div class="form-field form-field--text">
                            <label :for="`town_` + address_type.key"
                                >City</label
                            >
                            <input
                                v-model="form.town"
                                :readonly="is_same_hq"
                                type="text"
                                :id="`town_` + address_type.key"
                                :name="
                                    `address[` + address_type.key + `][town]`
                                "
                            />
                        </div>
                    </div>
                    <div
                        class="col-xl-3 col-lg-3 col-md-3"
                        v-if="states.length"
                    >
                        <div class="form-field form-field--tree">
                            <label :for="`state_` + address_type.key"
                                >State (USA)</label
                            >
                            <!--                            <select :name="`address[`+address_type.key+`][state]`" :id="`state_`+address_type.key" class="js-select-custom">-->
                            <!--                                <option value="">State</option>-->
                            <!--                                <option :value="state.id" v-for="state in states">{{ state.name }}</option>-->
                            <!--                            </select>-->
                            <treeselect
                                v-model="selectedState"
                                :id="`state_` + address_type.key"
                                :name="
                                    `address[` + address_type.key + `][state]`
                                "
                                :multiple="false"
                                :options="states"
                                @select="handleChanged"
                                @deselect="handleChanged"
                                :clearOnSelect="true"
                                :beforeClearAll="
                                    () => {
                                        handleChanged();
                                        return true;
                                    }
                                "
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xl-12 col-lg-12 col-md-12">
                <div class="row jus-c--space-between">
                    <div class="col-xl-8 col-lg-8 col-md-8">
                        <div class="form-field form-field--tree">
                            <label :for="`country_` + address_type.key"
                                >Country</label
                            >
                            <!--                            <select v-model="selectedCountry" :name="`address[`+address_type.key+`][country]`" :id="`country_`+address_type.key"-->
                            <!--                                    class="js-select-custom" @change="changeCountry">-->
                            <!--                                <option :selected="agency_address_info.country_id == country.id" :value="country.id" v-for="country in countries">{{ country.name }}</option>-->
                            <!--                            </select>-->
                            <treeselect
                                v-model="selectedCountry"
                                :clearOnSelect="true"
                                :id="`country_` + address_type.key"
                                :name="
                                    `address[` + address_type.key + `][country]`
                                "
                                :multiple="false"
                                @select="changeCountry"
                                @deselect="handleChanged"
                                :beforeClearAll="
                                    () => {
                                        handleChanged();
                                        return true;
                                    }
                                "
                                :options="sorted_countries"
                            />
                        </div>
                    </div>
                    <div class="col-xl-3 col-lg-3 col-md-3">
                        <div class="form-field form-field--text">
                            <label :for="`zip_` + address_type.key">Zip</label>
                            <input
                                v-model="form.zip"
                                type="text"
                                :readonly="is_same_hq"
                                :id="`zip_` + address_type.key"
                                :name="`address[` + address_type.key + `][zip]`"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div
                v-if="address_type.key === 'billing'"
                class="col-xl-12 col-lg-12 col-md-12"
            >
                <div class="row jus-c--space-between">
                    <div class="col=xl-8 col-lg-8 col-md-8">
                        <div
                            class="form-field checkbox-wrap checkbox-wrap--one-time-setup"
                            style="margin-top: 0"
                        >
                            <label>&nbsp;</label>
                            <input
                                v-model="is_same_hq"
                                type="checkbox"
                                id="same_as_hq"
                                class="one-time-setup"
                                :name="
                                    `address[` +
                                    address_type.key +
                                    `][same_as_hq]`
                                "
                                @change="onChangeSameHQCheckbox"
                            />
                            <label for="same_as_hq">
                                <i class="icon icon-checkmark"></i>
                            </label>
                            Same as HQ address
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

import { set_is_changed } from "../../helpers/_check_unsaved";

export default {
    name: "addressTab",

    components: {
        Treeselect,
    },
    props: [
        "countries",
        "address_type",
        "model_address_info",
        "default_country",
    ],
    data() {
        return {
            states: [],
            selectedCountry: null,
            selectedState: null,
            is_mounted: false,
            form: {
                address_line1: "",
                address_line2: "",
                town: "",
                zip: "",
            },
            sorted_countries: null,
            is_same_hq: this.model_address_info.same_as_hq,
        };
    },
    mounted() {
        console.log(this.model_address_info);
        this.selectedCountry =
            this.model_address_info.country_id ?? this.default_country.id;
        if (this.model_address_info.country_id || this.default_country) {
            this.changeCountry(
                {
                    id:
                        this.model_address_info.country_id ||
                        this.default_country.id,
                },
                this.model_address_info.country_id || this.default_country.id,
                true
            );

            this.selectedState = this.model_address_info.state_id;
        }

        this.sorted_countries = this.countries.sort((x, y) => {
            return x.id === this.default_country.id
                ? -1
                : x.label > y.label
                ? 1
                : x.label < y.label
                ? -1
                : 0;
        });

        this.form.address_line1 = this.model_address_info.address_line_1;
        this.form.address_line2 = this.model_address_info.address_line_2;
        this.form.town = this.model_address_info.town;
        this.form.zip = this.model_address_info.zip;
    },

    methods: {
        changeCountry(node, id, is_mounted = false) {
            console.log(node, id);
            axios
                .post("/agencies/address/getStatesByCountry", {
                    countryId: node.id,
                })
                .then((r) => {
                    this.states = r.data;
                })
                .finally(() => {
                    if (!is_mounted) set_is_changed();
                });
        },
        handleChanged() {
            set_is_changed();
        },

        onChangeSameHQCheckbox(e) {
            if (e.target.checked) {
                this.handleSetValuesFromHQ();
                this.is_same_hq = true;
            } else {
                this.is_same_hq = false;
            }
        },

        handleSetValuesFromHQ() {
            if (this.address_type.key === "billing") {
                const hq_address_line_1 = document.getElementById(
                    "address_line_1_hq"
                )
                    ? document.getElementById("address_line_1_hq").value
                    : "";
                const hq_address_line_2 = document.getElementById(
                    "address_line_2_hq"
                )
                    ? document.getElementById("address_line_2_hq").value
                    : "";
                const hq_town = document.getElementById("town_hq")
                    ? document.getElementById("town_hq").value
                    : "";
                const hq_state = document.querySelector("#state_hq input")
                    ? document.querySelector("#state_hq input").value
                    : null;
                const hq_country = document.querySelector("#country_hq input")
                    ? document.querySelector("#country_hq input").value
                    : null;
                const hq_zip = document.getElementById("zip_hq")
                    ? document.getElementById("zip_hq").value
                    : "";

                this.form.address_line1 = hq_address_line_1;
                this.form.address_line2 = hq_address_line_2;
                this.form.town = hq_town;
                this.form.zip = hq_zip;
                this.selectedCountry = hq_country;
                this.selectedState = hq_state;

                this.changeCountry(
                    {
                        id: hq_country,
                    },
                    this.model_address_info.country_id ||
                        this.default_country.id,
                    true
                );
            }
        },
    },
};
</script>
